var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6673 19.4454C11.5735 19.5392 11.4463 19.5919 11.3137 19.5919C11.1811 19.5919 11.0539 19.5392 10.9602 19.4454L6.71753 15.2028C6.62376 15.109 6.57108 14.9818 6.57108 14.8492C6.57108 14.7166 6.62376 14.5894 6.71753 14.4957C6.81129 14.4019 6.93847 14.3492 7.07108 14.3492C7.20369 14.3492 7.33087 14.4019 7.42463 14.4957L10.8138 17.8848L10.8131 3.53553C10.8131 3.40275 10.8658 3.27541 10.9597 3.18153C11.0536 3.08764 11.1809 3.03489 11.3137 3.03489C11.4465 3.03489 11.5738 3.08764 11.6677 3.18153C11.7616 3.27541 11.8144 3.40275 11.8144 3.53553L11.8136 17.8848L15.2028 14.4957C15.2966 14.4019 15.4238 14.3492 15.5564 14.3492C15.689 14.3492 15.8161 14.4019 15.9099 14.4957C16.0037 14.5894 16.0564 14.7166 16.0564 14.8492C16.0564 14.9818 16.0037 15.109 15.9099 15.2028L11.6673 19.4454Z",
    fill: "#0E65D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11.3137 22.6274) rotate(-135)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderArrow);
export default __webpack_public_path__ + "static/media/header_arrow.9a04b70d1dc13c07921c57b32f0f06fb.svg";
export { ForwardRef as ReactComponent };